<template>
    <div>
        <div class="modal fade" id="myAccountZeus" tabindex="-1" aria-labelledby="myAccountZeusLabel" aria-hidden="true"
            data-bs-backdrop="false">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" :style="skin.header_desktop.nav_bar">
                    <div class="modal-body p-4" style="font-family: 'Exo 2', sans-serif !important;">
                        <div class="container">
                            <!-- <button id="closemyAccountZeus" :style="skin.my_account.close_btn"
                                    style="background:transparent;float: right;color:white" type="button" class="btn-close"
                                    data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button> -->
                            <h3 style="color: white;"><span class="fa fa-table mb-3"></span> Historial de cuenta</h3>
                            <div class="row">
                                <div class="col-md-2 col-sm-12 mb-2">
                                    <input type="date" v-model="date" class="input-custom">
                                </div>
                                <div class="col-md-2 col-sm-12 mb-2">
                                    <select v-model="filter" name="" id="" class="input-custom">
                                        <option value="todo">Ver Todo</option>
                                        <option value="ultimos">Ultimas jugadas</option>
                                        <option value="cargas">Depositos/Retiros</option>
                                    </select>
                                </div>
                                <div class="col-md-2 col-sm-12">
                                    <button @click="getData" class="btn w-100" :style="{'background-color':skin.main_modal_background, 'color':skin.main_modal_text}" style="font-size: small;font-weight: bold;">BUSCAR</button>
                                </div>
                                <div style="color: white">
                                    <span>La plataforma solo almacena movimientos de casino hasta por 7 dias</span>
                                </div>

                            </div>
                            <div v-if="loading_report" style="width:100%" class="text-center p-2">
                                <div class="spinner-border" style="color:beige" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <div class="table-responsive my-3">
                                <table class="table" style="color:white;font-size: 15px;">
                                    <thead :style="{'color':skin.main_modal_background}">
                                        <tr>
                                            <th scope="col">Fecha</th>
                                            <th scope="col">Operación</th>
                                            <th scope="col">Juego</th>
                                            <th scope="col">Monto</th>
                                            <th scope="col">Balance Previo</th>
                                            <th scope="col">Balance Posterior</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in paginarArray(reportData, registers_per_page)[actual_page - 1]" :key="index">
                                            <td>{{ formatearFecha(item.fecha) }}</td>
                                            <td>{{ item.operacion }}</td>
                                            <td>{{ item.juego }}</td>
                                            <td>{{ parseNumbers(item.valor) }}</td>
                                            <td>{{ parseNumbers(item.antiguo_capital) }}</td>
                                            <td>{{ parseNumbers(item.nuevo_capital) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="report.length < 1" class="text-center" style="font-size: 3em;color: white;font-family: 'passionone-bold', sans-serif !important;">
                                    <span>REGISTROS NO ENCONTRADOS</span>
                                </div>
                            </div>
                            <div>
                                <pagination class="float-end" :options="paginationConf" v-model="actual_page" :records="records" :per-page="registers_per_page" @paginate="paginate"/>
                            </div>
                        </div>
                        <br><br><br>
                        <div class="text-center">
                            <button class="btn" :style="{'background-color':skin.main_modal_background, 'color':skin.main_modal_text}" style="font-size: small;font-weight: bold;" data-bs-dismiss="modal" aria-label="Close">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import Pagination from 'vue-pagination-2';
import MyPagination from './pagination.vue'
import axios from 'axios';
export default {
    name: "myAccountZeus",
    props: ['skin', 'translation', 'language'],
    components:{Pagination},
    data() {
        return {
            report:[],
            filter:'todo',
            date: new Date().toISOString().split('T')[0],
            actual_page:1,
            records:0,
            registers_per_page:10,
            paginationConf:{
                texts:{count:''},
                template:MyPagination
            },
            loading_report:false
        }
    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        apiUrlnew(){
            return this.$store.getters['getApiUrlnew'];
        },
        site(){
            return this.$store.getters['getSite'];
        },
        reportData(){
            let mainData = this.report;
            if(this.filter=='cargas'){
                return mainData.filter(item=>item.operacion == "Carga" || item.operacion == "Retiro")
            }
            if(this.filter=='ultimos'){
                return mainData.filter(item=>item.operacion !== "Carga" & item.operacion !== "Retiro")
            }
            return mainData
        }
    },
    methods: {
        paginate(page){
            this.actual_page = page;
        },
        paginarArray(array, elementosPorPagina) {
            const paginas = [];
            let paginaActual = [];

            for (let i = 0; i < array.length; i++) {
                if (paginaActual.length === elementosPorPagina) {
                    paginas.push(paginaActual);
                    paginaActual = [];
                }
                paginaActual.push(array[i]);
            }

            if (paginaActual.length > 0) {
                paginas.push(paginaActual);
            }
            this.records = array.length;
            this.pages = paginas;
            return paginas;
        },
        async getData() {
            this.loading_report=true;
            const timeZoneOffset = new Date().getTimezoneOffset() / 60;
            const timezoneFormated = ((Math.abs(timeZoneOffset)<9 ?((-1*(timeZoneOffset)) < 0 ? '-0'+timeZoneOffset: '0'+timeZoneOffset):(-1*(timeZoneOffset))))+":00";
            let data = await axios.post(this.apiUrlnew +"historial_jugador", {
                "username": this.user.user_data.data.user_name,
                "startDate": this.date+" 00:00:00",
                "endDate": this.date+" 23:59:59",
                "timezone": timezoneFormated,
                "token":this.user.token,
                "site": this.site
            })
            this.report = data.data
            this.loading_report=false;
        },
        parseNumbers(number){
            return new Intl.NumberFormat("de-DE",{minimumFractionDigits:2, maximumFractionDigits: 2}).format(number)
        },  
        formatearFecha(fechaString) {
            const fecha = new Date(fechaString);
            const anio = fecha.getFullYear();
            const mes = this.agregarCeroDelante(fecha.getMonth() + 1);
            const dia = this.agregarCeroDelante(fecha.getDate());
            const Hora = this.agregarCeroDelante(fecha.getHours());
            const Minutos = this.agregarCeroDelante(fecha.getMinutes());
            const Segundos = this.agregarCeroDelante(fecha.getSeconds());
            return `${anio}/${mes}/${dia} ${Hora}:${Minutos}:${Segundos}`;
        },
        agregarCeroDelante(numero) {
            return numero < 10 ? '0' + numero : numero;
        },
    },
    mounted() {
        const fechaHoy = new Date();
        fechaHoy.setHours(0, 0, 0, 0); // Establecer horas, minutos, segundos y milisegundos a 0
        const fechaHoyISO = fechaHoy.toISOString().split('T')[0];
        this.date = fechaHoyISO;
        this.$root.$on('getMovementsHistory', () => {
            this.getData(); 
        });
    }
}
</script>
  
<style scoped>
.input-bets{
    background-color: #161616 !important;
    font-size: 1rem !important;
    color: #fff !important;
    border-color: #383c61 !important;
}
.input-custom{
    font-size: 1rem;
    background-color: #2e2e2e;
    color: #fff;
    border-radius: 6px;
    padding: 10px 20px;
    line-height: .75em;
    width: 100%;
    border: 1px solid rgba(22, 22, 22, .082);
}
</style>./pagination.vue